import { WorkstationLevelGarmentsCompletion } from "./workstation-level-garments.model";

export class LineWiseGarmentsModel {
    lineId: string; // may duplicate based on the style within the day
    lineDesc: string;
    plannedGarments: number; // for the line and style
    completedGarments: number; // last op garments
    styleId: string;
    styleDesc: string;
    buyer: string;
    rejectedGarments: number; // the last op rejected garments
    totalOperators: number; // total operators working in the line

    hour: number;

    workstationLevelGarmentsCompletion: WorkstationLevelGarmentsCompletion[];

    constructor(lineId: string, // may duplicate based on the style within the day
        lineDesc: string,
        plannedGarments: number, // for the line and style
        completedGarments: number, // last op garments
        styleId: string,
        styleDesc: string,
        buyer: string,
        rejectedGarments: number,
        totalOperators: number,
        hour: number,
        workstationLevelGarmentsCompletion: WorkstationLevelGarmentsCompletion[]) {
            this.lineId = lineId;
            this.lineDesc = lineDesc;
            this.plannedGarments = plannedGarments;
            this.completedGarments = completedGarments;
            this.styleId = styleId;
            this.styleDesc = styleDesc;
            this.buyer = buyer;
            this.rejectedGarments = rejectedGarments;
            this.totalOperators = totalOperators;
            this.hour = hour;
            this.workstationLevelGarmentsCompletion = workstationLevelGarmentsCompletion;
    }
}